import { initializeApp } from "firebase/app";
import {
  getAnalytics,
  isSupported as analyticsSupported,
} from "firebase/analytics";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

// Firebase configuration pulled from environment variables.
// Make sure corresponding keys in your .env file are prefixed with VITE_.
const firebaseConfig = {
  apiKey: "AIzaSyCO3pL8Q9leLfa8FvHLXmol8ekDd17deXk",
  authDomain: "vetriaai-mvp.firebaseapp.com",
  projectId: "vetriaai-mvp",
  storageBucket: "vetriaai-mvp.appspot.com",
  messagingSenderId: "263194063371",
  appId: "1:263194063371:web:0fe594d6be4815b8214d0e",
  measurementId: "G-DSQ473YKGQ",
};

// Initialize Firebase
export const firebaseApp = initializeApp(firebaseConfig);

// Initialize Functions with region
export const functions = getFunctions(firebaseApp, 'us-central1');

// Connect to emulator in development if needed
// Uncomment the following line if you're using Firebase emulator
// if (process.env.NODE_ENV === 'development') {
//   connectFunctionsEmulator(functions, "localhost", 5001);
// }

// Initialise Analytics (only when available – it fails on some platforms like SSR)
export let firebaseAnalytics;
if (typeof window !== "undefined") {
  analyticsSupported().then((supported) => {
    if (supported) {
      firebaseAnalytics = getAnalytics(firebaseApp);
    }
  });
}

// Secondary Firebase app for admin user creation
// This allows admins to create new users without affecting their own auth state
let secondaryApp = null;

export const getSecondaryApp = () => {
  if (!secondaryApp) {
    secondaryApp = initializeApp(firebaseConfig, "Secondary");
  }
  return secondaryApp;
};

